module.exports = "//public.getcloudapp.com/packs/media/images/check-mark-a45b1d7b17f3b4a9790993fb9bde52fa.svg";